import React, {useEffect} from "react";

export const AppInitializer = ({setupServerUri}) => {

    useEffect(setupServerUri, []);

    return <div/>
}
